import { Image, ImageSource } from "expo-image";
import { Modal, Pressable, StyleSheet, View } from "react-native";

interface ImagePreviewModalProps {
  visible: boolean;
  onClose: () => void;
  uri?: string;
  fallback?: ImageSource | number;
  alt?: string;
}

export function ImagePreviewModal({
  visible,
  onClose,
  uri,
  fallback,
  alt,
}: ImagePreviewModalProps) {
  return (
    <Modal
      animationType="fade"
      transparent
      visible={visible}
      onRequestClose={onClose}
    >
      <Pressable
        style={styles.overlay}
        onPress={onClose}
        testID="image-preview-overlay"
      >
        <View
          style={styles.imageWrapper}
          testID="image-preview-content"
          onStartShouldSetResponder={() => true}
          onResponderRelease={(e) => e.stopPropagation()}
        >
          <Image
            source={uri ? { uri } : fallback}
            placeholder={fallback}
            contentFit="contain"
            cachePolicy="disk"
            transition={150}
            accessibilityLabel={alt}
            style={styles.image}
          />
        </View>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.85)",
    justifyContent: "center",
    alignItems: "center",
  },
  imageWrapper: {
    width: "90vw" as unknown as number,
    height: "90vh" as unknown as number,
    maxWidth: "90vw" as unknown as number,
    maxHeight: "90vh" as unknown as number,
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    width: "100%",
    height: "100%",
  },
});
